import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const PageHeader = ({ eyebrow, title, description, actions }) => (
    <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', md: 'flex-end' }} spacing={2.5}>
        <Box>
            {eyebrow && <Typography variant="overline" color="secondary.main" sx={{ fontWeight: 800, letterSpacing: '.12em' }}>{eyebrow}</Typography>}
            <Typography variant="h4" component="h1">{title}</Typography>
            {description && <Typography color="text.secondary" sx={{ mt: .75, maxWidth: 720 }}>{description}</Typography>}
        </Box>
        {actions && <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>{actions}</Stack>}
    </Stack>
);

export default PageHeader;
